import { isMobile } from 'is-mobile';
import * as React from 'react';
import smsLink from 'sms-link';

interface GenerateSmsLinkProps {
  number: string;
  label: string;
  content: string;
}

const SmsLink: React.FC<GenerateSmsLinkProps> = (props) => {
  const { number, label, content } = props;
  if (isMobile()) {
    return (
      <p>
        <a href={smsLink({ phone: number, body: content })}>{label}</a>
      </p>
    );
  }
  return null;
};

SmsLink.displayName = 'SmsLink';
export default SmsLink;
